module.exports = __webpack_public_path__ + "static/media/NoteBlock_logo_tm.04568835.png";